import { useState, useEffect } from 'react';
import { formatNumber } from "src/MarketDataComponents/Helpers";
import { generateGuid } from 'src/Utils';

const rowMappings = [
    {
        title: 'Price / Earnings', 
        fieldName: 'priceEarnings'
    },
    {
        title: 'Price / Book', 
        fieldName: 'priceBook'
    },
    {
        title: 'Price / Sales', 
        fieldName: 'priceSales'
    },
    {
        title: 'Price / Cash flow', 
        fieldName: 'priceCashFlow'
    },
    {
        title: 'Dividend-yield factor', 
        fieldName: 'dividendYieldFactor'
    },
    {
        title: 'Long-term projected earnings growth', 
        fieldName: 'longProjectedEarningsGrowth'
    },
    {
        title: 'Historical earnings growth', 
        fieldName: 'historicalEarningsGrowth'
    },
    {
        title: 'Sales growth', 
        fieldName: 'salesGrowth'
    },
    {
        title: 'Cash-flow growth', 
        fieldName: 'cashFlowGrowth'
    },
    {
        title: 'Book-value growth', 
        fieldName: 'bookValueGrowth'
    },
];

export default function GrowthRates({equityValuation, equityValuationCategory, formattedDate}) {
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        let showTable = false;
        rowMappings.map(row => {
            if (equityValuation[row.fieldName]) {
                showTable = true;
            }
        });

        setShowTable(showTable);
    }, []);

    // fieldName
    const renderRow = row => {
        return <tr key={generateGuid()}>
            <td data-testid={`${row.fieldName}Label`}>{row.title}</td>
            <td className="text-align-right text-align-left-sm" data-testid={`${row.fieldName}FundValue`}>{formatNumber(equityValuation[row.fieldName], 2)}</td>
            <td className="text-align-right text-align-left-sm" data-testid={`${row.fieldName}CatValue`}>{formatNumber(equityValuationCategory[row.fieldName], 2)}</td>
        </tr>
    }

    return <div className="ajb-grid-row">
        <div className="ajb-col-collapse">
            <div className="ajb-col-12 ajb-col-8-breakpoint">
                <div className="card z-depth-0 margin-0">
                    <div className="card-content padding-0">
                        <div className="ajb-grid-row margin-top-20">
                            <div className="ajb-col-collapse">
                                <div className="ajb-col-12 ajb-col-8-breakpoint margin-top-30-sm">
                                    <div className="card z-depth-0 margin-0">
                                        {showTable ? <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                                            <div className="ajb-grid-row">
                                                <span className="card-title float-left float-none-sm" data-testid="valuationsAndGrowthRatesHeader">Valuations and growth rates</span>
                                                {formattedDate ? <p className="h7 float-right float-none-sm" data-testid="valuationsAndGrowthRatesDate">{formattedDate}</p> : null}
                                            </div>
                                            <div className="ajb-grid-row">
                                                <table className="data-table data-table--small data-table--scroll margin-0 highlight">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="text-align-right" data-testid="growthFundTableHead">Fund</th>
                                                            <th className="text-align-right" data-testid="growthCatTableHead">Category</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rowMappings.map((row, index) => {
                                                            return renderRow(row, index);
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}